import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Aligner } from '@alfa-bank/site-aligner';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Background } from '@alfa-bank/site-background';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { Link } from '@alfa-bank/site-link';

import type { ITilesDepsDesktop, TTilesDesktop } from '../../../models';
import { TilesLayoutDesktop as TilesLayout } from '../../layout';

import { TilesComponentDesktop as Component } from './tiles';

export const TilesDesktop = createWidget<ITilesDepsDesktop, TTilesDesktop>({
    Aligner,
    Block,
    Background,
    Text,
    Layout,
    Link,
    TilesLayout,
})(Component);
